var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarSingleBlue = function SvgStarSingleBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#starSingleBlue_svg__a)",
    d: "m14.55 8.494 3.242 1.167c.32.112.32.575 0 .687l-3.243 1.166a5.1 5.1 0 0 0-3.035 3.035l-1.166 3.243c-.112.32-.575.32-.687 0L8.494 14.55a5.1 5.1 0 0 0-3.035-3.035l-3.243-1.166c-.32-.112-.32-.575 0-.687l3.243-1.167A5.1 5.1 0 0 0 8.494 5.46l1.167-3.243c.112-.32.575-.32.687 0l1.166 3.243a5.1 5.1 0 0 0 3.035 3.035"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "starSingleBlue_svg__a",
    x1: 2.319,
    x2: 17.502,
    y1: 18.032,
    y2: 17.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6195EB"
  })))));
};
export default SvgStarSingleBlue;